export default [
    {
        path: 'organizational',
        name: 'organizational',
        meta: {
            title: '机构管理',
            auth: true
        },
        component: () =>
            import('@/views/labor/organizational.vue')
    },
    {
        path: 'roleManagement',
        name: 'roleManagement',
        meta: {
            title: '角色管理',
            auth: true
        },
        component: () =>
            import('@/views/labor/roleManagement.vue')
    },
    {
        path: 'employeeManagement',
        name: 'employeeManagement',
        meta: {
            title: '职员管理',
            auth: true
        },
        component: () =>
            import('@/views/labor/employeeManagement.vue')
    },
    {
        path: 'accountManagement',
        name: 'accountManagement',
        meta: {
            title: '账号管理',
            auth: true
        },
        component: () =>
            import('@/views/labor/accountManagement.vue')
    },
    {
        path: 'laborPersonnelInfor',
        name: 'laborPersonnelInfor',
        meta: {
            title: '劳务人员信息',
            auth: true
        },
        component: () =>
            import('@/views/labor/laborPersonnelInfor.vue')
    },

    {
        path: 'blacklistManagement',
        name: 'blacklistManagement',
        meta: {
            title: '黑名单管理',
            auth: true
        },
        component: () =>
            import('@/views/labor/blacklistManagement.vue')
    },

]